import React, { useEffect, useState } from 'react';

import { TournamentTypeEnum } from '@app/dev/constants/enums/tournament';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { useDataFetch } from '@common/hooks/dataFetch';
import Loader from '@common/components/loader';
import TournamentListItem from './components/listItem';

import './style.scss';

const Tournaments = () => {
  const [refetchCounter, setRefetchCounter] = useState(0);
  const [data, , initialLoading] = useDataFetch(() => swarmRequest({ product_type_id: TournamentTypeEnum.Sport }, 'get_tournament_list'), [refetchCounter]);

  useEffect(() => {
    const timeout = setTimeout(() => setRefetchCounter(refetchCounter + 1), 20000);
    return () => clearTimeout(timeout);
  }, [refetchCounter]);

  if (initialLoading) return <Loader />;

  return data ? (
    <secion className="tournaments-wrapper">
      {data.result.map((item) => <TournamentListItem key={item.Id} tournament={item} />)}
    </secion>
  ) : null;
};

export default Tournaments;
